import { useTheme } from "@emotion/react";
import { BarTimeChartSynced } from "./bar_time_chart";
import { getBarTimeChartOptions, applyAutoScale } from "./chart_options";

export function InternalChart({ metering, multiDay = false }) {
  const theme = useTheme();
  const totalFlex = (data) => {
    if (data.flex_charge && data.flex_discharge) return data.flex_charge - data.flex_discharge;
    else if (data.flex_charge && !data.flex_discharge) return data.flex_charge;
    else if (data.flex_discharge && !data.flex_charge) return -data.flex_discharge;
    else return 0;
  };
  const utctime = metering.map((el) => new Date(1000 * el.utctime));
  const flex = metering.map((el) => totalFlex(el));

  const prod = metering.map((el) => -el.total_production);
  const cons = metering.map((el) => el.total_consumption);

  const curt_prod = metering.map((el) => -el.curtailment_production);
  const curt_cons = metering.map((el) => el.curtailment_consumption);

  const eff_prod = prod.map((total, index) => total - curt_prod[index]);
  const eff_cons = cons.map((total, index) => total - curt_cons[index]);

  const data = {
    labels: utctime,
    datasets: [
      {
        fill: true,
        label: "Flex",
        data: flex,
        borderWidth: 0,
        borderColor: theme.palette.flex.main,
        backgroundColor: theme.palette.flex.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
      {
        fill: true,
        label: "Consumption",
        data: eff_cons,
        borderWidth: 0,
        borderColor: theme.palette.consumption.main,
        backgroundColor: theme.palette.consumption.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
      {
        label: "Uncurtailed Production",
        data: eff_prod,
        backgroundColor: theme.palette.production.main,
      },
      {
        label: "Curtailed Production",
        data: curt_prod,
        backgroundColor: theme.palette.curtailment.main,
      },
      {
        label: "Curtailed Consumption",
        data: curt_cons,
        backgroundColor: theme.palette.curtailment.main,
      },
    ],
  };

  const options = getBarTimeChartOptions(multiDay);
  applyAutoScale(options, [flex, eff_cons, eff_prod, curt_prod, curt_cons], "W");

  return <BarTimeChartSynced data={data} options={options} />;
}
